import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#0d1117',
          color: '#e6edf3',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1 style={{ color: '#ff1744', marginBottom: '16px' }}>Something went wrong</h1>
          <p style={{ color: '#8b949e', marginBottom: '24px', maxWidth: '500px' }}>
            The application encountered an unexpected error. Please try refreshing the page.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              backgroundColor: '#238636',
              color: '#ffffff',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              marginTop: '24px',
              padding: '16px',
              backgroundColor: '#161b22',
              borderRadius: '6px',
              maxWidth: '600px',
              overflow: 'auto',
              fontSize: '12px',
              color: '#ff6b6b',
              textAlign: 'left'
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
